import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppRouting } from '../app.routing';

import { ComponentsModule } from '@app/components/components.module';
import { KeproLandingComponent } from './kepro-landing/kepro-landing.component';

@NgModule({
  declarations: [
    KeproLandingComponent
  ],
  imports: [
    CommonModule,
    AppRouting,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
  ],
  providers: [],
})
export class KeproModule {}
